module.exports = __webpack_public_path__ + "cd346cdc7caa416803025986e843a600.svg";